if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart = document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.upsellVariantId = this.dataset.upsellVariantId;
        this.hideErrors = this.dataset.hideErrors === 'true';

        if (this.cart) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.error = false;
        this.handleErrorMessage();

        this.cart = document.querySelector('cart-drawer');
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_url}.js`)
          .then((response) => {
            if (!response.ok) throw new Error('No se pudo consultar el carrito.');
            return response.json();
          })
          .then((cartState) => {
            if (cartState.item_count === 0 && this.upsellVariantId) {
              return fetch(
                routes.cart_add_url,
                this.getUpsellProductConfig()
              ).then(async (response) => {
                const result = await response.json();
                if (!response.ok || result.status) {
                  throw new Error(
                    result.description || 'No se pudo añadir el producto adicional.'
                  );
                }
              });
            }
          })
          .then(() => fetch(routes.cart_add_url, config))
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);
              this.error = true;

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message');

              if (soldOutMessage) {
                const label = this.submitButton.querySelector('span');
                if (label) label.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              }

              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });

            if (!this.cart) {
              this.handleErrorMessage(
                'Producto añadido. Activa el carrito tipo Cajón en la configuración del tema para abrirlo aquí.'
              );
              return;
            }

            this.cart.classList.remove('is-empty');

            const quickAddModal = this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => this.cart.renderContents(response));
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((error) => {
            console.error(error);
            this.handleErrorMessage(
              error.message || 'No se pudo añadir el producto. Inténtalo nuevamente.'
            );
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');

            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }

            if (spinner) spinner.classList.add('hidden');
          });
      }

      getUpsellProductConfig() {
        const upsellFormData = new FormData();
        upsellFormData.append('id', this.upsellVariantId);
        upsellFormData.append('quantity', 1);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = upsellFormData;

        return config;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}